import { Modal } from 'antd';
import ChildQuickSearch from '@/components/child-quick-search';
import { useAddGroupMemberMutation } from '@/services/sibling-group-api';
import { useNavigate } from 'react-router-dom';

const AddModal = ({ groupId, open, refetch, onClose }) => {
  const [addMember] = useAddGroupMemberMutation();
  const navigate = useNavigate();

  const handleAdd = async (childId) => {
    try {
      const res = await addMember({ childId: groupId, selectedChildId: childId }).unwrap();
      navigate(`/sibling-group/${res.siblingGroupId}/edit`);
      refetch();
      onClose();
    } catch (err) {}
  };

  return (
    <Modal title="Child quick search" open={open} cancelText="Close" onCancel={onClose} width={800} footer={null}>
      <ChildQuickSearch onSelect={handleAdd} />
    </Modal>
  );
};

export default AddModal;
